import { getRewardsActionCreator } from 'actions/bountyActions'
import { connect, MapDispatchToPropsFunction } from 'react-redux'
import { rewardsFilterSelector } from 'selectors/bountySelectors'
import { createSelector } from 'reselect'
import { RewardsFilter } from 'interfaces/bounty'
import withMobile from 'hocs/withMobile/withMobile'
import RewardDetailsTabs, { RewardDetailsTabsDispatchProps, RewardDetailsTabsStateProps } from 'components/features/pfm/RewardDetailsTabs/RewardDetailsTabs'

const mapStateToProps = createSelector(
  rewardsFilterSelector,
  (active): RewardDetailsTabsStateProps => ({
    active,
  }),
)
const mapDispatchToProps: MapDispatchToPropsFunction<RewardDetailsTabsDispatchProps> = (dispatch) => ({
  onTabClick: (filter: RewardsFilter) => dispatch(getRewardsActionCreator.request({ filter, page: 1 })),
})

const RewardDetailsTabsContainer = connect<
  RewardDetailsTabsStateProps, RewardDetailsTabsDispatchProps
>(mapStateToProps, mapDispatchToProps)(
  withMobile(
    RewardDetailsTabs
  ),
)

export default RewardDetailsTabsContainer
